export default __webpack_public_path__ + "static/media/CNo.55-2.e6fc55c5.jpg";